export enum Permission {
  ADD_SELF_SCAN_GEMS = 'Add Self-Scan Gems',
  SCAN_WITH_KRISTA_KROMA = 'Scan with KRISTA™/KROMA™',
  VIEW_MY_GEM_VAULT = 'View myGemVault',
  MANAGE_MY_GEM_VAULT = 'Manage myGemVault',
  GENERATE_PASSPORT = 'Generate Passport/Passport Lite',
  SUBSCRIPTION_MANAGEMENT = 'Subscription Management',
  ACCESS_GEM_GPT = 'Access GemGPT™',
  PROVIDE_USAGE_FEEDBACK = 'Provide Usage Feedback to Porolis',
  VIEW_POROLIS_GEM_BANK = 'View Porolis GemBank',
}
